// Game version - single source of truth
// This version is automatically injected into the service worker at build time
export const GAME_VERSION_NUMBER = '13.26.1';
export const GAME_VERSION = `${GAME_VERSION_NUMBER} (pixelsoccermanagerx@gmail.com)`;
